/** Motion for the mobile bottom sheet, shared by every sheet in the app. */
export const DEFAULT_SHEET_TWEEN = { ease: [0.33, 1.15, 0.66, 1], duration: 0.4 }

/** Mirror of the opening overshoot: the sheet lifts slightly before sliding out. */
export const SHEET_CLOSE_EASE = [0.33, -0.15, 0.66, 1]

/** Extra time so the unmount lands after the exit animation has finished painting. */
const EXIT_GRACE_MS = 40

/** How long to keep a closing sheet mounted, in ms. */
export const getSheetExitMs = (tweenConfig = DEFAULT_SHEET_TWEEN) =>
  Math.round((tweenConfig?.duration || DEFAULT_SHEET_TWEEN.duration) * 1000) + EXIT_GRACE_MS
